import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffb3e722"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["action"]
const _hoisted_3 = ["id", "name", "value"]
const _hoisted_4 = ["id", "name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      disabled: !_ctx.isAllConfigSet,
      id: "confirm-button",
      class: "button confirm-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, "注文内容の確認画面へ", 8, _hoisted_1),
    _withDirectives(_createElementVNode("form", {
      ref: "formRef",
      id: "ec-post-form",
      action: _ctx.link,
      method: "post"
    }, [
      _createElementVNode("input", {
        type: "hidden",
        id: _ctx.apiKeyId,
        name: _ctx.apiKeyId,
        value: _ctx.apiKey
      }, null, 8, _hoisted_3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (item, index) => {
        return (_openBlock(), _createElementBlock("input", {
          key: index,
          type: "hidden",
          id: item.id,
          name: item.id,
          value: item.value
        }, null, 8, _hoisted_4))
      }), 128))
    ], 8, _hoisted_2), [
      [_vShow, _ctx.formVisible]
    ])
  ], 64))
}